import { createSelector } from 'reselect';

export const pendingCustomerSelector = createSelector(
  (state) => state && state.customer && state.customer.customerPending,
  (pendingCustomerSelector) => pendingCustomerSelector
);
export const pointsCustomerSelector = createSelector(
  (state) => state && state.customer && state.customer.customerPoints,
  (pointsCustomerSelector) => pointsCustomerSelector
);
export const previewPhotoIdSelector = createSelector(
  (state) => state && state.customer && state.customer.previewPhotoId,
  (previewPhotoIdSelector) => previewPhotoIdSelector
);
export const previewPointImageSelector = createSelector(
  (state) => state && state.customer && state.customer.previewPointImage,
  (previewPointImageSelector) => previewPointImageSelector
);

export const machineSelector = createSelector(
  (state) => state && state.settings && state.settings.machines,
  (machineSelector) => machineSelector
);

export const gameSelector = createSelector(
  (state) => state && state.settings && state.settings.games,
  (gameSelector) => gameSelector
);
export const assignTemplatesSelector = createSelector(
  (state) => state && state.settings && state.settings.assignTemplates,
  (assignTemplatesSelector) => assignTemplatesSelector
);
export const readingSelector = createSelector(
  (state) => state && state.settings && state.settings.reading,
  (readingSelector) => readingSelector
);
export const readingsSelector = createSelector(
  (state) => state && state.settings && state.settings.readings,
  (readingsSelector) => readingsSelector
);
export const allSessionIdsSelector = createSelector(
  (state) => state && state.settings && state.settings.sessionIds,
  (allSessionIdsSelector) => allSessionIdsSelector
);

export const differenceListSelector = createSelector(
  (state) => state && state.settings && state.settings.differenceList,
  (differenceListSelector) => differenceListSelector
);

export const employeeTicketsSelector = createSelector(
  (state) => state && state.settings && state.settings.employeeTickets,
  (employeeTicketsSelector) => employeeTicketsSelector
);

export const matchSessionSelector = createSelector(
  (state) => state && state.settings && state.settings.matchSession,
  (matchSessionSelector) => matchSessionSelector
);

export const clockRecordSelector = createSelector(
  (state) => state && state.settings && state.settings.clockRecord,
  (clockRecordSelector) => clockRecordSelector
);

export const employeeSessionSelector = createSelector(
  (state) => state && state.settings && state.settings.employeeSession,
  (employeeSessionSelector) => employeeSessionSelector
);
export const manageBonusSelector = createSelector(
  (state) => state && state.settings && state.settings.manageBonus,
  (manageBonusSelector) => manageBonusSelector
);
export const claimBonusSelector = createSelector(
  (state) => state && state.settings && state.settings.claimBonus,
  (claimBonusSelector) => claimBonusSelector
);

export const previewBonusSelector = createSelector(
  (state) => state && state.settings && state.settings.bonusImage,
  (previewBonusSelector) => previewBonusSelector
);

// Bonus photos still waiting on this device. Lives on the ticketOut slice with
// the rest of the bonus actions (see constants/ticketOut).
export const bonusPhotoQueueSelector = createSelector(
  (state) =>
    (state && state.ticketOut && state.ticketOut.bonusPhotoQueue) || {
      count: 0,
      bonusIds: [],
      stalled: 0,
      uploading: null,
    },
  (bonusPhotoQueue) => bonusPhotoQueue
);
export const bonusSelector = createSelector(
  (state) => state && state.settings && state.settings.bonus,
  (bonusSelector) => bonusSelector
);
export const rulesSelector = createSelector(
  (state) => state && state.settings && state.settings.rules,
  (rulesSelector) => rulesSelector
);
export const allMachinePictureSelector = createSelector(
  (state) => state && state.settings && state.settings.allMachinePictures,
  (allMachinePictureSelector) => allMachinePictureSelector
);
export const loadingSelector = createSelector(
  (state) => state.settings.loadingData,
  (loadingSelector) => loadingSelector
);
export const categorySelector = createSelector(
  (state) => state && state.settings && state.settings.categories,
  (categorySelector) => categorySelector
);
export const availableEmployeeSelector = createSelector(
  (state) =>
    state && state.settings && state.settings.availableEmployeeSessions,
  (availableEmployeeSelector) => availableEmployeeSelector
);
export const loadStartedSessionSelector = createSelector(
  (state) => state && state.settings && state.settings.loadStartedSession,
  (loadStartedSessionSelector) => loadStartedSessionSelector
);
export const notesSelector = createSelector(
  (state) => state && state.settings && state.settings.notes,
  (notesSelector) => notesSelector
);
export const reportSelector = createSelector(
  (state) => state && state.settings && state.settings.report,
  (reportSelector) => reportSelector
);
export const summarySelector = createSelector(
  (state) => state && state.settings && state.settings.summary,
  (summarySelector) => summarySelector
);
export const employeeSummarySelector = createSelector(
  (state) => state && state.settings && state.settings.employeeSummary,
  (employeeSummarySelector) => employeeSummarySelector
);
export const managerSettingSelector = createSelector(
  (state) => state && state.settings && state.settings.managerSetting,
  (managerSettingSelector) => managerSettingSelector
);
export const managerSummarySelector = createSelector(
  (state) => state && state.settings && state.settings.managerSummary,
  (managerSummarySelector) => managerSummarySelector
);

export const summaryBreakdownSelector = createSelector(
  (state) => state && state.settings && state.settings.summaryBreakdown,
  (summaryBreakdownSelector) => summaryBreakdownSelector
);

export const shortAnalysisSelector = createSelector(
  (state) => state && state.settings && state.settings.shortAnalysis,
  (shortAnalysis) => shortAnalysis
);

export const maintenancePermitSelector = createSelector(
  (state) => state && state.settings && state.settings.maintenancePermit,
  (permit) => permit
);

export const maintenancePermitHistorySelector = createSelector(
  (state) => state && state.settings && state.settings.maintenancePermitHistory,
  (history) => history || []
);
